import ProductCard from "./ProductCard";
import BalancePill from "./BalancePill";
import SkeletonCard from "./SkeletonCard";


const MetalSection = ({
  metal,
  refObj,
  products,
  balances,
  screen,
  nextStep,
  getSingleProduct,
  loading,
}) => {
  const scroll = (ref, direction) => {
    if (!ref.current) return;
    const container = ref.current;
    let visibleCards = 4;
    if (screen === 'tablet') visibleCards = 3;
    if (screen === 'mobile') visibleCards = 1;
    const cardWidth = container.offsetWidth / visibleCards;
    const scrollAmount = cardWidth + 10;
    container.scrollBy({
      left: direction === 'left' ? -scrollAmount : scrollAmount,
      behavior: 'smooth',
    });
  };

  const showButton = () => {
    if (screen === 'mobile') return products.length > 1;
    if (screen === 'tablet') return products.length > 3;
    return products.length > 4;
  };

  const getCenteredClass = () => {
    if (screen === 'mobile') return products.length < 1 ? 'centered' : '';
    if (screen === 'tablet') return products.length < 3 ? 'centered' : '';
    return products.length < 4 ? 'centered' : '';
  };

  const title =
    metal === 'gold'
      ? 'Buy Gold Coins and Bars with 99.99% Purity'
      : 'Buy Silver Coins and Bars with 99.99% Purity';

  const balanceLabel =
    metal === 'gold' ? 'Your Digital Gold:' : 'Your Digital Silver:';

  const balanceValue =
    metal === 'gold' ? `${balances.gold} g` : `${balances.silver} g`;

  const minCards =
    screen === 'mobile'
      ? 1
      : screen === 'tablet'
        ? metal === 'gold'
          ? 3
          : 3
        : metal === 'gold'
          ? 4
          : 3;
  const skeletonsToAdd = Math.max(minCards - products.length, 0);

  return (
    <div className={`${metal}-container ${getCenteredClass()}`}>
      <div className='heading-row'>
        <h4 className={`${metal}-heading`}>{title}</h4>
        <BalancePill label={balanceLabel} value={balanceValue} type={metal} />
      </div>

      <div className='product-swiper-container'>
        {showButton() && (
          <button
            className='swiper-button-prev'
            onClick={() => scroll(refObj, 'left')}
          >
            <svg
              width='16'
              height='16'
              viewBox='0 0 24 24'
              fill='none'
              stroke='#301250'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            >
              <polyline points='15 18 9 12 15 6' />
            </svg>
          </button>
        )}

        <div className='product-swiper' ref={refObj}>
          <div className='swiper-wrapper'>
            {/* {loading
              ? Array(screen === 'mobile' ? 1 : screen === 'tablet' ? 3 : 4)
                .fill(null)
                .map((_, index) => (
                  <div className='swiper-slide' key={`${metal}-skeleton-${index}`}>
                    <SkeletonCard />
                  </div>
                ))
              : products.map((product, index) => (
                <div className='swiper-slide' key={product.itemCode}>
                  <ProductCard
                    product={product}
                    nextStep={nextStep}
                    getSingleProduct={getSingleProduct}
                    isFirst={index === 0}
                  />
                </div>
              ))} */}

            {/* {(loading || products.length === 0)
              ? Array(screen === 'mobile' ? 1 : screen === 'tablet' ? 3 : 4)
                .fill(null)
                .map((_, index) => (
                  <div className='swiper-slide' key={`${metal}-skeleton-${index}`}>
                    <SkeletonCard />
                  </div>
                ))
              : products.map((product, index) => (
                <div className='swiper-slide' key={product.itemCode}>
                  <ProductCard
                    product={product}
                    nextStep={nextStep}
                    getSingleProduct={getSingleProduct}
                    isFirst={index === 0}
                  />
                </div>
              ))} */}

            {products.map((product, index) => (
              <div className='swiper-slide' key={product.itemCode}>
                <ProductCard
                  product={product}
                  nextStep={nextStep}
                  getSingleProduct={getSingleProduct}
                  isFirst={index === 0}
                />
              </div>
            ))}

            {Array(skeletonsToAdd)
              .fill(null)
              .map((_, index) => (
                <div
                  className='swiper-slide'
                  key={`${metal}-skeleton-${index}`}
                >
                  <SkeletonCard />
                </div>
              ))}
          </div>
        </div>

        {showButton() && (
          <button
            className='swiper-button-next'
            onClick={() => scroll(refObj, 'right')}
          >
            <svg
              width='16'
              height='16'
              viewBox='0 0 24 24'
              fill='none'
              stroke='#301250'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            >
              <polyline points='9 18 15 12 9 6' />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
};

export default MetalSection;
